module.exports = __webpack_public_path__ + "img/unlike.b7457b0c.svg";